import { eventPrefix } from "./growth-experiments.types";
const cookieBannerPrefix = "CookieBanner--";
export const cookieBannerEventNames = {
    siteDetected: `${eventPrefix}${cookieBannerPrefix}SiteDetected`,
    cpmMessageDetected: `${eventPrefix}${cookieBannerPrefix}CpmMessageDetected`,
    buttonInjected: `${eventPrefix}${cookieBannerPrefix}ButtonInjected`,
    buttonClicked: `${eventPrefix}${cookieBannerPrefix}ButtonClicked`,
};
